/* unplugin-vue-components disabled */import { render } from "./DcCheckBox.vue?vue&type=template&id=09e7764f"
import script from "./DcCheckBox.vue?vue&type=script&lang=js"
export * from "./DcCheckBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__